import React from 'react';

export const BillImageViewer = (props: any) => {
    return (
        <img src={props.src} />
    )
}
